import { Link } from 'react-router-dom';

const reasons = [
  { icon: 'ri-global-line', title: '15+ Years Experience', desc: 'Deep expertise across pharmaceutical, fine chemical, food, and industrial sectors.' },
  { icon: 'ri-translate-2', title: 'Bilingual EN / FR', desc: 'Full service in English and French — no barriers, no miscommunication.' },
  { icon: 'ri-lock-line', title: 'Total Confidentiality', desc: 'Your identity and strategy remain protected throughout every engagement.' },
  { icon: 'ri-map-pin-line', title: '4 Global Regions', desc: 'Active networks in North America, Europe, China, and India.' },
];

export default function ServicesCTA() {
  return (
    <>
      {/* Why us strip */}
      <section className="w-full bg-stone-50 py-16 px-6 md:px-16 border-t border-stone-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">Why MAX-Sourcing</span>
            <h2
              className="text-3xl md:text-4xl font-extrabold text-stone-800 mt-3"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              The Difference Is in the Details
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {reasons.map((r) => (
              <div key={r.title} className="bg-white rounded-lg border border-stone-100 p-6 flex flex-col gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-emerald-50 text-emerald-600">
                  <i className={`${r.icon} text-xl`} />
                </div>
                <h4 className="text-stone-800 font-bold text-sm">{r.title}</h4>
                <p className="text-stone-500 text-xs leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA banner */}
      <section className="w-full relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://public.readdy.ai/ai/img_res/a4871a4f8a8255d9dc8a487b9a4114ce.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/70 to-emerald-900/60" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 py-20 flex flex-col lg:flex-row items-center justify-between gap-10">
          <div className="max-w-2xl">
            <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest block mb-4">Ready to Start?</span>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-4"
              style={{ fontFamily: "'DM Serif Display', serif" }}
            >
              Let&apos;s Solve Your Sourcing Challenge
            </h2>
            <p className="text-white/70 text-base leading-relaxed">
              Whether you need a single qualified supplier or a complete supply chain overhaul, our team is ready to engage — confidentially, professionally, and with full regulatory awareness.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col gap-4 shrink-0">
            <Link
              to="/contact"
              className="bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Contact Us Today
            </Link>
            <Link
              to="/suppliers"
              className="border-2 border-white/40 hover:border-white text-white font-bold text-sm px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Become a Supplier
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
